import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function shouldAlwaysShowBcc() {
    var userOptions = getUserConfiguration().UserOptions;
    return userOptions.AlwaysShowBcc;
}
//# sourceMappingURL=shouldAlwaysShowBcc.js.map